exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/page-not-access-swal/page-not-access-swal.component.scss
// module id = ../../../../../src/app/page-not-access-swal/page-not-access-swal.component.scss
// module chunks = main